// Copyright (c) 2016 Deere & Company

import AllPartReturns from './components/all-part-requests';
import Facets from './state/facets';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';

const getStateToBindToContainerProps = state => ({
    allPartReturns: state.partReturns.allPartReturns.partReturns,
    busyCounter: state.partReturns.allPartReturns.busyCounter,
    exportToExcel: state.exportToExcel,
    facets: new Facets({
        ...state.partReturns.allPartReturns.facets,
        dealerAccountsFacet: {
            ...state.partReturns.allPartReturns.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        },
        partReturnStatusesFacet: {
            ...state.partReturns.allPartReturns.facets.partReturnStatusesFacet,
            allowedStatuses: state.user.details.settings.partReturns.status.selectedStatuses
        },
        requestDateFacet: {
            ...state.partReturns.allPartReturns.facets.requestDateFacet,
            dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
            numberOfDays: state.user.details.settings.partReturns.numberOfDays
        }
    }),
    hasSearchResultsLoaded: !state.partReturns.search.facets.isInitialLoad,
    openPartReturnsCount: state.partReturns.openPartReturns.partReturns.length,
    searchByDropdown: state.partReturns.search.searchByDropdown,
    searchFilters: state.partReturns.allPartReturns.searchFilters,
    searchQueryString: state.partReturns.search.searchQueryString,
    searchResultsCount: state.partReturns.search.filteredSearchResults.length
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AllPartReturns);



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/state-connector.js